const isLayoutRequiresBaseUnit = (unit) => unit == null ? void 0 : unit.isDefined;
export default isLayoutRequiresBaseUnit;
